<template>
  <div id="Report">
  

  <v-dialog
    v-model="AddCourseDialog"
    scrollable
    width="500"
    class="dialog"
    style="borderRadius:5px; zIndex:2"
    persistent
    
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="amber darken-2"
        dark
        class="elevation-6 px-3"
         v-on="on"
        @click="showReportButton"
        
        >
        <v-icon small class="mr-1" >mdi-alert</v-icon>
        Report
      </v-btn>
    </template>

       <v-card v-if="this.user === undefined || this.user === null" style="borderRadius:10px">
        <v-card-title class="title grey lighten-2 text-xs-center">You Need an Account <v-spacer></v-spacer> <v-icon @click="AddCourseDialog = false" color="red">mdi-close</v-icon></v-card-title>
        <v-card-text class="text-xs-justify mt-2" >
           You need an active subscription to report an error
        </v-card-text>
       

        <v-card-actions class="py-1 pb-2">
         <v-layout justify-center>
          <v-btn to="/LoginSignupPage" style="width:48%"  class="elevation-0 mx-2 " color="green" dark @click="showCreateSubscriptionDialog = false">
            Login
          </v-btn>
           <v-btn to="/signup" style="width:48%"  class="elevation-0" color="primary" @click="showCreateSubscriptionDialog = false">
            Signup
          </v-btn>
          </v-layout>
 
        </v-card-actions>
      </v-card>

      <v-card v-else-if="this.user.subscriptions === undefined || this.user.subscriptions === null" style="borderRadius:10px">
        <v-card-title class="title grey lighten-2 text-xs-center">You need a subscription <v-spacer></v-spacer><v-icon color="red" @click="AddCourseDialog = false">mdi-close</v-icon></v-card-title>
        <v-card-text class="text-xs-justify mt-2" >
          You need an active subscription to report an error.
        </v-card-text>
       

        <v-card-actions class="py-1 pb-2">
           <v-btn to="/myaccount" block class="elevation-0" color="primary" @click="showCreateSubscriptionDialog = false">
            My Account
          </v-btn>
          
        
        </v-card-actions>
      </v-card>

      <v-card v-else style="borderRadius:5px;">
          <v-toolbar card color="amber darken-2 elevation-0" dark>
            <v-icon>mdi-alert</v-icon>
            <v-toolbar-title>Report Error </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-icon @click="AddCourseDialog = false">mdi-close</v-icon>
          </v-toolbar>

          <v-card-text>
          If you noticed an error in the data please notify our team at data@mypabox.com
          </v-card-text>

          <!-- Email Button -->
          <v-layout justify-center class="mx-2">  
            <v-btn
              href="mailto:data@mypabox.com" 
              color="blue"
              dark
              class="mb-3 elevation-0 "
              block
              >
              <v-icon small class="mr-1">mdi-email</v-icon>
              Send Email
              
            </v-btn>
          </v-layout>

      </v-card>
  </v-dialog>

            
  </div>
</template>

<script>
   export default {
    data() {
      return {
        modal: false,
        AddCourseDialog : false,
        signupLoginDialog: false,
      }
    },
    methods: {
      showReportButton() {
        
     console.log(this.user)

     
          // this.AddCourseDialog === true
          
        // if(user !== null && user !== undefined ){
        //   this.AddCourseDialog = true
        // }
        // else {
        //   this.alert = true
        // }
      }
    },
    computed: {
      user() {
      return this.$store.getters.user;
      },
    }
   }
</script>

<style scoped>
  a {
    text-decoration: none;
  }

  #buttonShadow { 
    box-shadow: 0 10px 30px -10px #11111130;
  }

</style>



// WEBPACK FOOTER //
// src/components/Shared/Report.vue